import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { SolvTheme } from '@solvhealth/jigsaw-v1';
import styled from 'styled-components';
import history from '../../core/history';
import Button, { ButtonVariations } from '../SolvPatternLibrary/Button';
import { colors } from '~/constants/colors';
import { fontFamily } from '~/constants/text';
import { biggerThanOrEqualTo, smallerThanOrEqualTo } from '~/core/util/styledComponents';
import { useSolvSelector } from '~/reducers';
import { formatPhone } from '~/core/util/string';

const Content = styled.div.withConfig({ componentId: 'sc-13tkunm-0' })`
  box-sizing: border-box;
  padding: 10vh 5vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  ${smallerThanOrEqualTo.tablet`
    padding: unset;
  `}
  ${biggerThanOrEqualTo.tablet`
    padding: 10vh 10vw;
  `}
`;

const Img = styled.img.withConfig({ componentId: 'sc-13tkunm-1' })`
  width: 320px;
  ${smallerThanOrEqualTo.tablet`
    margin: 69px auto 13px auto;
    width: 192px;
    height: fit-content;
  `}
`;

const Title = styled.div.withConfig({ componentId: 'sc-13tkunm-2' })`
  font-family: ${fontFamily.medium};
  font-size: 2em;
  color: ${colors.crunchBerry};
  text-align: center;
  padding: 12px;
`;

const ErrorContent = styled.div.withConfig({ componentId: 'sc-13tkunm-3' })`
  font-size: 1em;
  color: ${colors.blueMonday};
  text-align: center;
  padding: 12px 12px 48px;
`;

const goToHomepage = () => {
  history.push('/');
};

export default function InvalidPhoneNumber() {
  const buttonVariant = useMediaQuery(`screen and (max-width: ${SolvTheme.breakpoints.sm})`)
    ? ButtonVariations.link
    : ButtonVariations.pinkPrimary;
  const { phone } = useSolvSelector((state) => state.location);

  return (
    <Content>
      <Img
        alt="hand holding phone with invalid phone number"
        src="/images/paperwork/hand_with_phone_wrong_number.png"
      />

      <Title>This phone number doesn’t match</Title>

      <ErrorContent>
        The phone number used for your booking doesn’t match the phone number on your account.
        {phone && (
          <>
            <br />
            <br />
            If you need help, please contact the clinic at{' '}
            <a href={`tel:${phone}`}>{formatPhone(phone)}</a>.
          </>
        )}
      </ErrorContent>
      <Button onClick={goToHomepage} variation={buttonVariant} width="240px">
        Return to homepage
      </Button>
    </Content>
  );
}
